import { collapse } from '@/utils/cookies'

const app = {
  state: {
    collapse: collapse.get()
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.collapse = !state.collapse;
      state.collapse
      ? collapse.set(true)
      : collapse.del()
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js